import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarSendIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M12.8763 1.9209H11.1233V8.11624L8.15743 5.11636L7.03369 6.2401L11.9998 11.2062L16.966 6.2401L15.8422 5.11636L12.8763 8.11624V1.9209ZM5.14561 11.4348L6.58692 8.44922L7.73079 9.59308L6.26761 12.5772H17.7324L16.2802 9.61546L17.424 8.47171L18.8544 11.4348H21.0984V13.0668H19.6296L20.1192 14.0664V20.0232C20.1192 21.1452 19.2216 22.0632 18.0996 22.0632C17.2224 22.0632 16.3248 21.5328 16.1004 20.4312H7.89961C7.67521 21.5328 6.77761 22.0632 5.90041 22.0632C4.77841 22.0632 3.88081 21.1452 3.88081 20.0232V14.0664L4.37041 13.0668H2.90161V11.4348H5.14561ZM17.2224 19.7172C17.2224 20.1048 17.508 20.4108 17.8956 20.4108C18.2832 20.4108 18.5892 20.1048 18.5892 19.7172V14.1072H5.41081V19.7172C5.41081 20.1048 5.71681 20.4108 6.10441 20.4108C6.49201 20.4108 6.77761 20.1048 6.77761 19.7172V18.9012H17.2224V19.7172ZM12 16.3716C12.7752 16.3716 13.4484 15.984 13.8768 15.3924H17.0184V16.9224H14.4684C13.7952 17.4936 12.9384 17.8608 12 17.8608C11.0616 17.8608 10.2048 17.4936 9.53161 16.9224H6.98161V15.3924H10.1232C10.5516 15.984 11.2248 16.3716 12 16.3716Z"
      />
    </SvgIcon>
  );
});
